import React, { useEffect, useState } from "react";
import Navbar from "../Navbar";
import { Box, Button, TextField, Grid, Typography } from "@mui/material";
import axios from "axios";
import swal from "sweetalert";
import Divider from "@mui/material/Divider";
import { Link, useNavigate, useParams } from "react-router-dom";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import Select, { SelectChangeEvent } from "@mui/material/Select";
import DeleteIcon from "@mui/icons-material/Delete";
import {
  createTheme,
  PaletteColorOptions,
  ThemeProvider,
} from "@mui/material/styles";
import { Stack } from "@mui/material";

function TableDetails() {
  const navigate = useNavigate();

  const [inputFields, setInputFields] = useState([
    {
      distin: "",
      sn: "",
      descriptive: "",
      test: "",
      pltonns: "",
      swltonns: "",
    },
  ]);

  const { palette } = createTheme();
  const { augmentColor } = palette;
  const createColor = (mainColor) =>
    augmentColor({ color: { main: mainColor } });
  const theme = createTheme({
    palette: {
      anger: createColor("#F40B27"),
      apple: createColor("#A38A00"),
      steelBlue: createColor("#5C76B7"),
      violet: createColor("#BC00A3"),
    },
    button: {
      // Here is where you can customise the button
      fontSize: 16,
      fontWeight: 1700,
    },
  });

  const handleFormChange = (index, event) => {
    let data = [...inputFields];
    data[index][event.target.name] = event.target.value;
    setInputFields(data);
  };

  const submit = (e) => {
    e.preventDefault();

    const tabdata = inputFields;

    axios.post(`/api/store_details`, tabdata).then((res) => {
      if (res.data.status === 200) {
        swal("Success", res.data.message, "success");
        document.getElementById("CATEGORY_FORM").reset();
        navigate("/customermaster");
      } else if (res.data.status === 400) {
        setInputFields({ ...inputFields, error_list: res.data.errors });
      }
    });
    // console.log(inputFields);
    console.log(tabdata);
  };

  const addFields = () => {
    let object = {
      distin: "",
      sn: "",
      descriptive: "",
      test: "",
      pltonns: "",
      swltonns: "",
    };

    setInputFields([...inputFields, object]);
  };

  const removeFields = (index) => {
    let data = [...inputFields];
    data.splice(index, 1);
    setInputFields(data);
  };

  return (
    <form onSubmit={submit}>
      {inputFields.map((input, index) => {
        return (
          <div key={index}>
            {/* <input
        name='name'
        placeholder='Name'
        onChange={event => handleFormChange(event, index)}
        value={form.name}
      />
      <input
        name='age'
        placeholder='Age'
        onChange={event => handleFormChange(event, index)}
        value={form.age}
      /> */}
            <Grid container spacing={5}>
              <Grid item xs={3.5}>
                <TextField
                  fullWidth
                  name="distin"
                  onChange={(event) => handleFormChange(index, event)}
                  value={input.distin}
                  id="outlined-basic"
                  margin="normal"
                  label="Distinguish Mark"
                  variant="outlined"
                />
                {/* <span style={{color: "red"}} >{challanInput.error_list.party_name}</span> */}
              </Grid>
              <Grid item xs={3.5}>
                <TextField
                  fullWidth
                  name="sn"
                  onChange={(event) => handleFormChange(index, event)}
                  value={input.sn}
                  id="outlined-basic"
                  margin="normal"
                  label="S N"
                  variant="outlined"
                />
                {/* <span style={{color: "red"}} >{challanInput.error_list.party_name}</span> */}
              </Grid>
              <Grid item xs={3.5}>
                <TextField
                  fullWidth
                  name="descriptive"
                  onChange={(event) => handleFormChange(index, event)}
                  value={input.descriptive}
                  id="outlined-basic"
                  margin="normal"
                  label="Description/Dimension & Material of Gear/Device"
                  variant="outlined"
                />
                {/* <span style={{color: "red"}} >{challanInput.error_list.party_name}</span> */}
              </Grid>
            </Grid>
            <Grid container spacing={5}>
              <Grid item xs={3.5}>
                <TextField
                  fullWidth
                  name="test"
                  onChange={(event) => handleFormChange(index, event)}
                  value={inputFields.test}
                  id="outlined-basic"
                  margin="normal"
                  label="Nos. Tests"
                  variant="outlined"
                />
                {/* <span style={{color: "red"}} >{challanInput.error_list.party_name}</span> */}
              </Grid>
              <Grid item xs={3.5}>
                <TextField
                  fullWidth
                  name="pltonns"
                  onChange={(event) => handleFormChange(index, event)}
                  value={input.pltonns}
                  id="outlined-basic"
                  margin="normal"
                  label="P.L. Tonns"
                  variant="outlined"
                />
                {/* <span style={{color: "red"}} >{challanInput.error_list.party_name}</span> */}
              </Grid>
              <Grid item xs={3.5}>
                <TextField
                  fullWidth
                  name="swltonns"
                  onChange={(event) => handleFormChange(index, event)}
                  value={input.swltonns}
                  id="outlined-basic"
                  margin="normal"
                  label="SWL Tonns"
                  variant="outlined"
                />
                {/* <span style={{color: "red"}} >{challanInput.error_list.party_name}</span> */}
              </Grid>
              <Grid item xs={1}>
                <ThemeProvider theme={theme}>
                  <div className="delbut">
                    <Button
                      startIcon={<DeleteIcon color="inherit" />}
                      color="apple"
                      onClick={() => removeFields(index)}
                    ></Button>
                  </div>
                </ThemeProvider>
              </Grid>
            </Grid>

            <ThemeProvider theme={theme}>
              <Box
                marginTop={5}
                display="flex"
                padding={3}
                borderRadius={5}
                alignItems="center"
                justifyContent={"center"}
              >
                <Button
                  style={{
                    maxWidth: "200px",
                    maxHeight: "100px",
                    minWidth: "50px",
                    minHeight: "30px",
                  }}
                  color="apple"
                  type="submit"
                  variant="contained"
                  onClick={submit}
                >
                  Submit
                </Button>
              </Box>
              <Button onClick={addFields}>Add Details</Button>
            </ThemeProvider>
          </div>
        );
      })}
    </form>
  );
}

export default TableDetails;
